/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { UnespCoreEnvironment } from 'src/libs/unesp-core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'
import { InscricaoConsultaGerencial } from '../models/inscricao-consulta-gerencial'
import { FiltrosInscricaoForm } from '../models/filtros-inscricao-form'

@Injectable({
  providedIn: 'root',
})
export class ConsultaGerencialService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  listar(filtros: FiltrosInscricaoForm): Observable<InscricaoConsultaGerencial[]> {
    return this.http
      .put<InscricaoConsultaGerencial[]>(`${this.baseUrl}/consulta-gerencial`, filtros)
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
